module.exports = "/_next/static/images/d62d0af96a3e578e0d4f431eb7d655b1-card-background-left-lg.jpg";